import * as aor from "react-admin";
import React from "react";

import CardActions from "@material-ui/core/CardActions";
import AddressLink from "../../components/AddressLink";

import {
    POLICY_USERS,
    POLICY_NOTIFICATIONS
} from "../../common/rolesManagement";
import { getLoggedUserId, getPolicies } from "../../common/authClient";

const LOGGED_USER = getLoggedUserId();

const Filter = props => (
    <aor.Filter {...props}>
        <aor.TextInput source="username" alwaysOn={true} />
        <aor.TextInput source="surname" alwaysOn={true} />
        <aor.TextInput source="name" alwaysOn={true} />
        {props.permissions &&
            props.permissions.includes(POLICY_USERS.SHOW_COMPANY) && (
                <aor.TextInput source="company_name" alwaysOn={true} />
            )}
        {props.permissions &&
            props.permissions.includes(POLICY_USERS.SHOW_DISABLED) && (
                <aor.BooleanInput
                    source="deleted"
                    alwaysOn={true}
                    label="Disabilitati"
                />
            )}
    </aor.Filter>
);

const Actions = ({ permissions, basePath, _ }) => (
    <CardActions style={{ zIndex: 2, display: "inline-block", float: "right" }}>
        {permissions && permissions.includes(POLICY_USERS.CREATE) && (
            <aor.CreateButton basePath={basePath} />
        )}
    </CardActions>
);

const MyEditButton = ({ permissions, basePath, record, _ }) => {
    if (record && permissions.includes(POLICY_USERS.UPDATE)) {
        return <aor.EditButton basePath={basePath} record={record} />;
    }
    if (
        record &&
        permissions.includes(POLICY_USERS.SELF_UPDATE) &&
        LOGGED_USER === record.id
    ) {
        return <aor.EditButton basePath={basePath} record={record} />;
    }
    return <span />;
};

export default props => (
    <aor.List
        {...props}
        title="resources.users.views.list.title"
        actions={<Actions permissions={getPolicies()} />}
        filters={<Filter permissions={getPolicies()} />}
        sort={{ field: "username", order: "ASC" }}
        bulkActionButtons={false}
    >
        <aor.Datagrid>
            <AddressLink
                {...props}
                source="username"
                enabled={getPolicies().includes(
                    POLICY_NOTIFICATIONS.SEND_NOTIFICATIONS
                )}
            />
            <aor.TextField source="surname" />
            <aor.TextField source="name" />
            {getPolicies() &&
                getPolicies().includes(POLICY_USERS.SHOW_COMPANY) && (
                    <aor.ReferenceArrayField
                        reference="companies"
                        source="company_ids"
                        sortable={false}
                    >
                        <aor.SingleFieldList linkType="show">
                            <aor.ChipField source="name" />
                        </aor.SingleFieldList>
                    </aor.ReferenceArrayField>
                )}
            <aor.ShowButton />
            {getPolicies() && <MyEditButton permissions={getPolicies()} />}
        </aor.Datagrid>
    </aor.List>
);



// WEBPACK FOOTER //
// ./src/resources/Users/List.js